define('views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-week',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/weight-week',
    'views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-set',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightExerciseWeek,
    VWeightEditSet
) {

    var VWeightEditWeek = VWeightExerciseWeek.extend({
        exerciseSetView: VWeightEditSet,

        resetList: function() {
            this.$el.empty();
            this.removeChildViews({ defer: true });
            this.addAll(null, true);
        },
    });

    return VWeightEditWeek;

});

